<h4 class="center-text">Integration Identifiers</h4>
<br/>
<div *ngIf="integration">
  <div style="padding: 10px;">
    @if(settingsReady)
    {
      <app-lt-png-table [gridSettingsInput]="gridSettings()" (editClicked)="editIdentifier($event)" (deleteClicked)="deleteIntegrationIdentifier($event)"></app-lt-png-table>
    }
  </div>

  <button matButton="elevated" (click)="addIdentifier()" [disabled]="!checkAccess(['LOSTalker.Admin'])">Add Identifier</button>
  <button matButton="elevated" (click)="generateIdentifier()" [disabled]="!checkAccess(['LOSTalker.Admin'])">Generate Identifier</button>
</div>

@if (showAddUpdateForm && checkAccess(['LOSTalker.Admin']))
{
  <app-add-integration-identifier [isInTab]="true"
    [inputClient]="client()"
    [inputIntegration]="integration()"
    [inputSelectedIdentifier]="selectedIdentifier"
    [inputInAddMode]="inAddMode"
    [populatedAdd]="generatedNewIdentifier"
    (finished)="addUpdateFormFinished($event)"
    (outputIdentifier)="outputIdentifier($event)">
  </app-add-integration-identifier>
}